/* eslint-disable */
export default function focusWithinPolyfill() {
    function addListeners(parentClass){
        var focusableItems = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', '[tabindex="0"]'];
        for (var i = 0, leni = focusableItems.length; i < leni; i++) {
            var focusableElements = document.querySelectorAll("." + parentClass + " " + focusableItems[i]);
            for (var j = 0, lenj = focusableElements.length; j < lenj; j++) {
                focusableElements[j].addEventListener("focus", function() {
                    this.parentNode.parentNode.parentNode.classList.add("focus-within");
                });
                focusableElements[j].addEventListener("blur", function() {
                    this.parentNode.parentNode.parentNode.classList.remove("focus-within");
                });
            }
        }
    }
    addListeners("c-flip-cards__card");
}



// WEBPACK FOOTER //
// ./src/app/utils/focus-within.js